<template>
  <b-tabs class="configurations" content-class="pt-1">
    <b-tab title="System">
      <b-row justify-content-md>
        <b-col md="12" lg="6">
          <confidence-colors />
          <brands />
        </b-col>
        <b-col md="12" lg="6">
          <doc-retention v-bind:retentionTime="this.retentionTime" v-bind:retentionDaysCount="this.retentionDaysCount"/>
          <doc-escalation-time  v-bind:escalation-time="this.escalationTime" v-bind:escalationDaysCount="this.escalationDaysCount" />
          <process-type />
          <process-order />
          <role-order />
          <auto-processing v-bind:is_auto_processing="this.is_auto_processing"/>
          <local-time v-bind:local_time="this.local_time"/>
          <authConfig />
        </b-col>
      </b-row>
    </b-tab>
    <!-- <b-tab title="Teams">
      <b-row justify-content-md>
        <b-col md="12">
          <teams />
        </b-col>
      </b-row>
    </b-tab> -->
    <b-tab title="Service Mappings">
      <b-row justify-content-md>
        <b-col md="12">
          <external-service-maps />
        </b-col>
      </b-row>
    </b-tab>
    <b-tab title="Service Validations">
      <b-row justify-content-md>
        <b-col md="12">
          <external-service-validations />
        </b-col>
      </b-row>
    </b-tab>
    <b-tab title="Custom Validations">
      <b-row justify-content-md>
        <b-col md="12">
          <custom-validations />
        </b-col>
      </b-row>
    </b-tab>
    <b-tab title="Manage Fields">
      <b-row justify-content-md>
        <b-col md="12">
          <manageFields />
        </b-col>
      </b-row>
    </b-tab>
    <b-tab title="Auto Correct">
      <b-row justify-content-md>
        <b-col md="12">
          <autoCorrect />
          </b-col>
      </b-row>
    </b-tab>
    <!-- <b-tab title="ORTF Mappings">
      <b-row justify-content-md>
        <b-col md="12">
          <ortfMap />
        </b-col>
      </b-row>
    </b-tab>
    <b-tab title="HL7 Mappings">
      <b-row justify-content-md>
        <b-col md="12">
          <hl7Map />
        </b-col>
      </b-row>
    </b-tab> -->
    <b-tab title="API-Response Json Formatter">
      <b-row justify-content-md>
        <b-col md="12">
         <api-response-json-formatter />
        </b-col>
      </b-row>
    </b-tab>
  </b-tabs>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import router from '../../router'
import confidenceColors from '@/components/settings/confidenceColors'
import processOrder from '@/components/settings/processOrder'
import roleOrder from '@/components/settings/roleOrder'
import processType from '@/components/settings/processType'
// import teams from '@/components/settings/teams'
import externalServiceMaps from '@/components/settings/externalServiceMaps'
import externalServiceValidations from '@/components/settings/externalServiceValidations'
import manageFields from '@/components/settings/manageFields'
import autoCorrect from '@/components/settings/autoCorrect'
// import ortfMap from '@/components/settings/ortfMap'
// import hl7Map from '../../components/settings/hl7Map.vue'
import authConfig from '@/components/settings/authConfig'
import localTime from '@/components/settings/localTime'
import autoProcessing from '@/components/settings/autoProcessing'
import docRetention from '@/components/settings/docRetention'
import docEscalationTime from '@/components/settings/docEscalationTime'
import customValidations from '@/components/settings/customValidations'
import apiResponseJsonFormatter from '../../components/settings/apiResponseJsonFormatter.vue'
import brands from '../../components/settings/brands.vue'
export default {
  data () {
    return {
      local_time: null,
      is_auto_processing: false,
      retentionTime: null,
      escalationTime: null,
      retentionDaysCount: 0,
      escalationDaysCount: 0
    }
  },
  components: {
    'confidence-colors': confidenceColors,
    'process-order': processOrder,
    'role-order': roleOrder,
    'process-type': processType,
    // 'teams': teams,
    'external-service-maps': externalServiceMaps,
    'external-service-validations': externalServiceValidations,
    'manageFields': manageFields,
    'authConfig': authConfig,
    // 'ortfMap': ortfMap,
    // 'hl7Map': hl7Map,
    'autoCorrect': autoCorrect,
    'local-time': localTime,
    'auto-processing': autoProcessing,
    'docRetention': docRetention,
    'doc-escalation-time': docEscalationTime,
    'custom-validations': customValidations,
    'api-response-json-formatter': apiResponseJsonFormatter,
    'brands': brands
  },
  computed: {
    ...mapGetters(['isAdmin', 'isAdminRole', 'idToken'])
  },
  created () {
    Vue.axios.get('/admin/accounts/settings_config', { headers: { Authorization: `Bearer ${this.idToken}` } })
      .then(res => {
        this.local_time = res.data.local_time
        this.is_auto_processing = res.data.is_auto_processing
        this.retentionTime = res.data.doc_retention_period
        if (this.retentionTime.includes('day') || this.retentionTime.includes('days')) {
          this.retentionDaysCount = this.retentionTime.split(' ')[0]
        }
        this.escalationTime = res.data.doc_escaltion_time
        if (this.escalationTime.includes('day') || this.escalationTime.includes('days')) {
          this.escalationDaysCount = this.escalationTime.split(' ')[0]
        }
      })
      .catch(error => {
        if (error.status === 401) {
          console.log(this.$t('COMMON.MSG_EXPIRED'))
        } else {
          Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
        }
      })
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.isAdminRole) {
        next()
      } else {
        router.replace('/Not-Found-404')
      }
    })
  }
}
</script>
<style lang="scss">
.configurations {

  .tab-content {
    background: #f7f7f7
  }

  .nav-tabs .nav-link.active {
    color: black !important;
    border-radius: 5px 5px 0 0;
    border-bottom-color: #f7f7f7;
    background: linear-gradient(to top, #f7f7f7 90%, #737373 91%) !important;
  }

  .nav-tabs .nav-link{
    color: #737373;
  }

  .nav-link.disabled {
    cursor: not-allowed;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/settings/configurations.vue